export default __webpack_public_path__ + "static/media/kelasan-method.bd7b2a7b.jpg";